import { createRoot } from "react-dom/client";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import App from "./App.tsx";
import "./index.css";
import { reportWebVitals } from "./utils/webVitals";
import { loadGA } from "./lib/ga";
import { reportRuntimeError } from "./lib/telemetry";
import { isChunkError, reloadOnce } from "./lib/chunkReload";

// Nach einer Veröffentlichung fehlen alte Dateien: einmal automatisch neu laden.
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  reloadOnce();
});
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError(e.reason)) reloadOnce();
});

createRoot(document.getElementById("root")!).render(<App />);

// Attempt to load GA (no-op unless consent + live domain).
loadGA();

// Global runtime error hooks (consent-gated inside reportRuntimeError).
window.addEventListener("error", (e) => {
  reportRuntimeError({
    name: "runtime_error",
    message: e.message || "unknown",
    error_code: e.filename ? "window.error" : undefined,
  });
});
window.addEventListener("unhandledrejection", (e) => {
  const reason = e.reason instanceof Error ? e.reason.message : String(e.reason ?? "unhandledrejection");
  reportRuntimeError({
    name: "runtime_error",
    message: reason,
    error_code: "unhandledrejection",
  });
});

// Detect Lovable preview / iframe contexts where service workers cause stale caches
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com") ||
  window.location.hostname.includes("lovable.app");

if ((isPreviewHost || isInIframe) && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
} else if (import.meta.env.PROD) {
  reportWebVitals();
  // Service worker registration is handled automatically by vite-plugin-pwa
}
